import * as React from 'react';
import { IRiskPotReport } from '../../../models/IRiskPotReport';

interface IRiskPotReportHeader {
    riskPotReport: IRiskPotReport | undefined;
}

export const RiskPotReportHeader: React.FunctionComponent<IRiskPotReportHeader> = ({ riskPotReport }) => {

    return (
        <div className="card-header">
            <div className="row">
                <div className="col">
                    <h1>Riskpottsärende {riskPotReport ? `- ${riskPotReport.riskPotReportNumber}` : ""}</h1>
                </div>
            </div>
        </div>
    )

}